var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.users,"items-per-page":50,"must-sort":""},on:{"click:row":_vm.userSelected},scopedSlots:_vm._u([{key:"item.lastLogin",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDateTime(item.lastLogin))+" ")]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }